import PropTypes from 'prop-types';
const propTypes = {
    /** applied as data-hook HTML attribute that can be used to create driver in testing */
    dataHook: PropTypes.string,
    /** A css class to be applied to the component's root element */
    className: PropTypes.string,
    /** tooltip trigger element. Can be either string or renderable node */
    children: PropTypes.node.isRequired,
    /** tooltip content. Can be either string or renderable node */
    content: PropTypes.node,
    /** align tooltip content */
    textAlign: PropTypes.oneOf(['start', 'center']),
    /** time in milliseconds to wait before showing the tooltip */
    enterDelay: PropTypes.number,
    /**  time in milliseconds to wait before hiding the  Defaults to 0. */
    exitDelay: PropTypes.number,
    /** moves tooltip content relative to the parent by x or y */
    moveBy: PropTypes.shape({ x: PropTypes.number, y: PropTypes.number }),
    /** Moves arrow by amount */
    moveArrowTo: PropTypes.number,
    /** tooltips content calculation relation to a dom element. Can be either:
     *  `'window', 'scrollParent', 'viewport', 'parent'`, `element` or
     * `function` based predicate i.e. (elm) =>
     *  elm.getAttribute('data-hook') === 'value'
     */
    appendTo: PropTypes.oneOfType([
        PropTypes.oneOf(['window', 'scrollParent', 'viewport', 'parent']),
        PropTypes.element,
        PropTypes.func,
    ]),
    /** whether to enable the flip behaviour. This behaviour is used to flip the Tooltips placement when it starts to overlap the target element. */
    flip: PropTypes.bool,
    /** whether to enable the fixed behaviour. This behaviour is used to keep the Tooltip at it's original placement even when it's being positioned outside the boundary. */
    fixed: PropTypes.bool,
    /** tooltip content container width in pixels */
    maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    /** callback on tooltips content show event */
    onShow: PropTypes.func,
    /** callback on tooltips content hide event */
    onHide: PropTypes.func,
    /** tooltip content placement in relation to target element */
    placement: PropTypes.string,
    /** disables tooltip element trigger behaviour. If not specified, `disabled` prop of the `children` element will be used. */
    disabled: PropTypes.bool,
    /** sets size of the tooltip */
    size: PropTypes.oneOf(['small', 'medium']),
    /** establishes a relationship between tooltip element and tooltip content for a11y purposes */
    'aria-describedby': PropTypes.string,
    /** tooltips content zindex */
    zIndex: PropTypes.number,
    /** stretch root element to the width of its container. */
    fluid: PropTypes.bool,
};
export const TooltipCommonProps = {
    appendTo: propTypes['appendTo'],
    disabled: propTypes['disabled'],
    enterDelay: propTypes['enterDelay'],
    exitDelay: propTypes['exitDelay'],
    fixed: propTypes['fixed'],
    flip: propTypes['flip'],
    maxWidth: propTypes['maxWidth'],
    moveArrowTo: propTypes['moveArrowTo'],
    moveBy: propTypes['moveBy'],
    onHide: propTypes['onHide'],
    onShow: propTypes['onShow'],
    placement: propTypes['placement'],
    textAlign: propTypes['textAlign'],
    zIndex: propTypes['zIndex'],
    size: propTypes['size'],
};
//# sourceMappingURL=TooltipCommon.js.map